import ScarfIcon from 'icons/scarf.svg';
import PatternBucket from 'icons/pattern-bucket.svg';
import Repeat from 'icons/repeat.svg';
import RepetitionIcon from 'icons/repetition.svg';
import ToolsIcon from 'icons/tools.svg';

import WeaveSettings from './WeaveSettings.svelte';
import RepeatComponent from './Repeat.svelte';
import PatternFill from './PatternFill/PatternFill.svelte';
import WarpWeftFill from './WarpWeftFill.svelte';
import ReflectComponent from './Reflect.svelte';

export default [
  {
    icon: ScarfIcon,
    name: 'weave_settings',
    component: WeaveSettings,
  },
  {
    icon: PatternBucket,
    name: 'pattern_fill',
    component: PatternFill,
  },
  {
    icon: RepetitionIcon,
    name: 'repetition',
    component: WarpWeftFill,
  },
  {
    icon: Repeat,
    name: 'selection',
    component: RepeatComponent,
  },
  {
    icon: ToolsIcon,
    name: 'tools',
    component: ReflectComponent,
  },
];
